import React, { Component } from "react";

// Assets
import HomeIcon from "../../Assets/home.svg";

// Components
import Introduction from "./Introduction";
import FollowStep from "./FollowStep";
import Footer from "./Footer";
import Testimonial from "./Testimonial";
import ConsultingDoctors from "./ConsultingDoctors";
import AboutUs from "./AboutUs";

// Home Component
class Home extends Component {
  render() {
    return (
      <div className="Home">
        <div className="backBtn">
          <img src={HomeIcon} alt="Setting" />
        </div>
        <div className="Home_Holder">
          <Introduction />
          <FollowStep />
          <Testimonial />
          <ConsultingDoctors />
          <AboutUs />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Home;
